/* eslint-disable max-len */
import {
  conditionType,
  inputType
} from '../../../../../pages/esgManager/interface/inputType';
import {
  createHeading,
  createRowDatePickerField,
  createRowFileUploadField,
  createRowNumberField,
  createRowRadioGroupField,
  createRowSelectField,
  createRowWysiwygField,
  createSelectField,
  createTableWithFixedRowsQuestion,
  createTableQuestion,
  createRowMultiSelectField
} from '../../../Utils/questionHelper';
import {COUNTRY_OPTIONS} from '../SME/smeQuestions';

import {
  ACTION_TYPE,
  ACTIVE_DEFORESTATION_TARGET_OPTIONS,
  ACTIVITIES_ENGAGEMENT_TYPE_OPTIONS,
  ADDITIONAL_CONTROL_METHODS_OPTIONS,
  ASPECTS_OF_LEGISLATION_OPTIONS,
  ASSESS_LEGAL_COMPLIANCE_OPTIONS,
  CERTIFICATE_DETAILS_VOLUME_SOLID_OPTIONS,
  CERTIFICATION_OPTIONS,
  CLAIM_STATUS_OPTIONS,
  CLAIM_TYPE_OPTIONS,
  COLLECTIVE_MONITORING_FRAMEWORK_OPTIONS,
  COMMODITY_OPTIONS,
  CRITERIA_FOR_PRIORITIZING_LANDSCAPE_OPTIONS,
  CUTOFF_YEAR_OPTIONS,
  DF_DCF_STATUS_ASSESSED_OPTIONS,
  DISCLOSURE_OF_EMBEDDED_SOY_OPTIONS,
  EMISSIONS_ACCOUNTING_BOUNDARY_OPTIONS,
  EMISSIONS_ACCOUNTING_METHODOLOGY_OPTIONS,
  ENGAGEMENT_END_YEAR_OPTIONS,
  ENGAGEMENT_IN_LANDSCAPE_OPTIONS,
  EXCLUSION_OPTIONS,
  EXPECTED_BENEFITS_OF_PROJECT_OPTIONS,
  FORM_OF_COMMODITY_OPTIONS,
  GEOGRAPHIC_SCOPE_CUTOFF_YEAR_OPTIONS,
  GHG_EMISSIONS_REDUCTIONS_OPTIONS,
  GLOBAL_ENVIRONMENTAL_TREATIES_OPTIONS,
  INDICATE_COLLECT_COMPLIANCE_OPTIONS,
  INDICATE_IF_LAND_OWN_MANAGED_OPTIONS,
  INDICATE_IF_YOU_CAN_PROVIDE_VOLUME,
  INDICATE_SIZE_OF_AREA_INITIATIVE_OPTIONS,
  JURISDICTION_OPTIONS,
  LAND_CONTROL_TYPE_OPTIONS,
  LAND_TYPE_OPTIONS,
  LAND_USE_TYPE_OPTIONS,
  LANDSCAPE_GOALS_SUPPORTED_BY_ENGAGEMENT_OPTIONS,
  LANDSCAPE_JURISDICATION_OPTIONS,
  MAIN_MEASURES_IDENTIFIED_OPTIONS,
  MEASUREMENT_UNITS_OPTIONS,
  METHOD_TOOL_TRACEABILITY_OPTIONS,
  METRIC_OPTIONS,
  MONITORING_AND_ESTIMATING_OPTIONS,
  MONITORING_APPROACH_OPTIONS,
  MONITORING_FREQUENCY_OPTIONS,
  MONITORING_OR_ESTIMATING_OPTIONS,
  MONITORING_PROGRESS_OPTIONS,
  NO_DATA_REASON_OPTIONS,
  NO_DEFORESTATION_TARGET_OPTIONS,
  ORGANIZATION_ACTIONS_SUPPORTING_INITIATIVE_OPTIONS,
  ORGANIZATION_SUPPORT_OR_IMPLEMENTING_PROJECT_OPTIONS,
  OTHER_COMMODITY_TARGET_OPTIONS,
  PERCENTAGE_DISCLOSURE_VOLUME_OPTIONS,
  PRIMARY_REASON_CERTIFICATION_OPTIONS,
  PRIMARY_REASON_FOR_NOT_ENGAGING_OPTIONS,
  PRIMARY_REASON_ORGANIZATION_OPTIONS,
  PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS,
  PROCEDURE_TO_ENSURE_LEGAL_COMPLIANCE_OPTIONS,
  PROCESS_PLACE_OPTIONS,
  PRODUCE_SOURCE_DISCLOSURE_OPTIONS,
  PRODUCER_TYPES_OPTIONS,
  PRODUCTION_UNIT_MONITORING_OPTIONS,
  PROJECT_REFERENCE_OPTIONS,
  PROJECT_TAKING_PLACE_RELATION_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  RATIONALE_SELECTING_CUTOFF_OPTIONS,
  REASON_OPTIONS,
  REPORTING_OF_DEFORESTATION_OPTIONS,
  SCOPE_OPTIONS,
  SUBNATIONAL_AREA_OPTIONS,
  TARGET_CHALLENGES_OPTIONS,
  TARGET_CONTRIBUTION_OPTIONS,
  TARGET_DATE_OPTIONS,
  TARGET_LEVEL_OPTIONS,
  TARGET_LIST_OPTIONS,
  TARGET_METRIC_OPTIONS,
  TARGET_STATUS_REPORT_YEAR_OPTIONS,
  TARGET_VOLUME_OPTIONS,
  TARGET_YEAR_OPTIONS,
  THIRD_PARTY_CERTIFICATION_SCHEME_OPTIONS,
  TRACEABILITY_POINT_OPTIONS,
  TRACEABILITY_SYSTEM_OPTIONS,
  TRACEABILITY_SYSTEM_SOY_OPTIONS,
  TYPE_OF_ENGAGEMENT_OPTIONS,
  TYPE_OF_PARTNERS_ENGAGED_IN_INITIATIVE_OPTIONS,
  TYPE_OF_VERIFICATION_OPTIONS,
  VALUE_CHAIN_STAGE_OPTIONS,
  VOLUME_EXCLUDED_DISCLOSURE_OPTIONS,
  VOLUME_TYPE_OPTIONS,
  YES_NO_OPTIONS,
  YES_NO_UNKNOWN_OPTIONS,
  NO_DEFORESTATION_OR_NO_CONVERSION_TARGET_OPTIONS
} from './corporateOptions';
import {CDP_FORESTS_KEYS} from './corporateQuestionsKeys';

export const environmentalPerformanceForestsQuestions = [
  {
    key: 'Q1',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q1_VALUE,
        '8.1 Are there any exclusions from your disclosure of forests-related data?',
        'CDP seeks to share comprehensive and representative data to ensure data users’ confidence in the information reported. As such, if organizations need to exclude parts of their direct operations and/or upstream value chain from their disclosure of forests-related data, data users must be informed of the exclusions as this may affect their analysis.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q1_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowRadioGroupField(
            CDP_FORESTS_KEYS.Q1_2_VALUE,
            'Exclusion from disclosure',
            ['Yes', 'No']
          )
        ],
        false
      )
    ]
  },
  {
    key: 'Q2',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q2_VALUE,
        '8.1.1 Provide details on these exclusions.',
        'An organization’s disclosure must be comprehensive and representative to ensure data users’ confidence in the information reported. As such, organizations are encouraged to report on all exclusions of forests-related data from their direct operations and/or upstream value chain. This question helps data users contextualize responses to subsequent commodity-related questions.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_2_VALUE,
            'Exclusion',
            EXCLUSION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q2_3_VALUE,
            'Description of exclusion',
            2500
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_4_VALUE,
            'Value chain stage',
            VALUE_CHAIN_STAGE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_5_VALUE,
            'Reason for exclusion',
            REASON_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_6_VALUE,
            'Primary reason why data is not available for your disclosed commodity',
            NO_DATA_REASON_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q2_5_VALUE,
              condition: conditionType.NOT,
              values: ['Data is not available']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q2_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Data is not available'],
              required: true
            }
          ),
          createRowDatePickerField(
            CDP_FORESTS_KEYS.Q2_7_VALUE,
            'Completion date of acquisition or merger',
            'DD-MM-YYYY',
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q2_5_VALUE,
              condition: conditionType.NOT,
              values: ['Recent acquisition or merger']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q2_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Recent acquisition or merger'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_8_VALUE,
            'Data from the merger/acquisition will be incorporated in the next reporting year',
            YES_NO_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q2_5_VALUE,
              condition: conditionType.NOT,
              values: ['Recent acquisition or merger']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q2_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Recent acquisition or merger'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q2_9_VALUE,
            'Indicate if you are providing the commodity volume that is being excluded from your disclosure of forests-related data',
            VOLUME_EXCLUDED_DISCLOSURE_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q2_10_VALUE,
            'Volume excluded (metric tons)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q2_9_VALUE,
              condition: conditionType.NOT,
              values: ['Yes, we are providing the volume excluded']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q2_9_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes, we are providing the volume excluded'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q2_11_VALUE,
            'Please explain',
            1500
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q1_VALUE,
        CDP_FORESTS_KEYS.Q1_2_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q3',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q3_VALUE,
        '8.2 Provide a breakdown of your disclosure volume per commodity.',
        'Transparency on the commodity volumes included in an organization’s disclosure is key to data users’ understanding of environmental performance. This question requests the breakdown of the volume that is being disclosed on (here referred to as the “Disclosure volume”) according to the volume that is produced (“Produced volume”) and sourced (“Sourced volume”). This question helps data users to understand and contextualise the volumes that are being reported on in this module.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q3_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q3_2_VALUE,
            'Disclosure volume (metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q3_3_VALUE,
            'Volume type',
            VOLUME_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q3_4_VALUE,
            'Produced volume (metric tons)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q3_3_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['Produced']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q3_3_VALUE,
              condition: conditionType.INCLUDES,
              values: ['Produced'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q3_5_VALUE,
            'Sourced volume (metric tons)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q3_3_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['Sourced']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q3_3_VALUE,
              condition: conditionType.INCLUDES,
              values: ['Sourced'],
              required: true
            }
          )
        ],
        false
      )
    ]
  },

  {
    key: 'Q4',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_FORESTS_KEYS.Q4_VALUE,
        '8.2.1 Provide details on any soy embedded in animal products sourced by your organization.',
        `This question only appears if you select “Embedded soy only” or “Mixture of embedded soy and direct soy” in column 3 “Indicate if you have direct soy and/or embedded soy in your value chain” of ${'1.22.'} Modified guidance Global population growth is increasing the demand for animal products and consequently, increasing the demand for soy used to feed animals. This growth in soy production is linked to deforestation and conversion of natural ecosystems and usually goes unaccounted for, as it is “embedded” or “hidden” in organizations’ value chains. To address this, organizations who source animal products should: improve their awareness of their embedded soy exposure across the breadth of their product sourcing; work towards better visibility of their embedded soy origins; and assess their deforestation-free (DF) or deforestation- and conversion-free (DCF) status of their embedded soy volume. This question provides investors and other data users transparency on an organization's embedded soy use, in terms of its associated volume calculation, traceability, and DCF status.`,
        'Commodity',
        [{id: 'Soy', label: 'Soy'}],
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q4_1_VALUE,
            'Disclosure of embedded soy',
            DISCLOSURE_OF_EMBEDDED_SOY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q4_2_VALUE,
            'Description of embedded soy use and soy tiers',
            2500
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q4_3_VALUE,
            'Volume calculation methodology',
            3000
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q4_4_VALUE,
            'Embedded soy disclosure volume (metric tons)',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q4_5_VALUE,
            '% of sourced volume that is embedded soy',
            2
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q4_6_VALUE,
            'Traceability system',
            TRACEABILITY_SYSTEM_SOY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q4_7_VALUE,
            'Description of traceability system',
            3000,
            'Description of traceability system',
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q4_6_VALUE,
              condition: conditionType.NOT,
              values: [
                ' Yes, we have a traceability system for our embedded soy'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q4_6_VALUE,
              condition: conditionType.EQUALS,
              values: [
                ' Yes, we have a traceability system for our embedded soy'
              ],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q4_8_VALUE,
            '% of embedded soy disclosure volume traceable to country/area of soy production',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q4_6_VALUE,
              condition: conditionType.NOT,
              values: [
                ' Yes, we have a traceability system for our embedded soy'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q4_6_VALUE,
              condition: conditionType.EQUALS,
              values: [
                ' Yes, we have a traceability system for our embedded soy'
              ],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q4_9_VALUE,
            '% of embedded soy disclosure volume for which the soy production origin is unknown',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q4_6_VALUE,
              condition: conditionType.NOT,
              values: [
                ' Yes, we have a traceability system for our embedded soy'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q4_6_VALUE,
              condition: conditionType.EQUALS,
              values: [
                ' Yes, we have a traceability system for our embedded soy'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q4_10_VALUE,
            'DF/DCF status assessed for embedded soy',
            DF_DCF_STATUS_ASSESSED_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q4_11_VALUE,
            '% of embedded soy disclosure volume determined as DF/DCF in the reporting year',
            2
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q4_12_VALUE,
            'Methodology used to determine DF/DCF status',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q4_10_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, deforestation-free (DF) status assessed',
                'Yes, deforestation and conversion-free (DCF) status assessed'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q4_10_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, deforestation-free (DF) status assessed',
                'Yes, deforestation and conversion-free (DCF) status assessed'
              ],
              required: true
            }
          )
        ]
      )
    ]
  },

  {
    key: 'Q5',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q5_VALUE,
        '8.3 Provide details on the land you own, manage and/or control that is used to produce your disclosed commodities.',
        'This question gathers information on the land that you own, manage and/or control that is used to produce your disclosed commodities. The data disclosed provides an indication of your market power and potential influence over land use in different regions including eventual links to deforestation and the conversion of natural ecosystems. It is important to demonstrate to investors and other stakeholders that your organization has a good understanding of the land it owns, manages, or controls.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q5_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q5_2_VALUE,
            'Type of control',
            LAND_CONTROL_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q5_3_VALUE,
            'Country/area',
            COUNTRY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q5_4_VALUE,
            'First-level administrative division',
            JURISDICTION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q5_5_VALUE,
            'Specify the states or equivalent jurisdictions',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q5_4_VALUE,
              condition: conditionType.NOT,
              values: ['States/equivalent jurisdictions']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q5_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['States/equivalent jurisdictions'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q5_6_VALUE,
            'Land type',
            LAND_TYPE_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q5_1_VALUE,
              condition: conditionType.NOT,
              values: ['Timber products']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q5_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['Timber products'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q5_7_VALUE,
            'Area (hectares)',
            2
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q5_8_VALUE,
            'Indicate if you can provide the volume produced on land you own, manage and/or control',
            INDICATE_IF_YOU_CAN_PROVIDE_VOLUME
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q5_9_VALUE,
            'Volume produced on land you own, manage and/or control (metric tons)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q5_8_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q5_8_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q5_10_VALUE,
            '% area third-party certified',
            2
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q5_11_VALUE,
            'Third-party certification scheme',
            CERTIFICATION_OPTIONS,
            true
          ),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q5_12_VALUE,
            'Attach a list of production facility names and locations (optional)'
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q3_VALUE,
        CDP_FORESTS_KEYS.Q3_3_VALUE,
        ['Produced']
      )
    ]
  },

  {
    key: 'Q6',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '8.4 Indicate if any of the land you own, manage and/or control was not used to produce your disclosed commodities in the reporting year.'
          },
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_FORESTS_KEYS.Q6_VALUE,
            fieldLabel:
              'This question gathers information on if any of the land you own, manage and/or control was not used for the production of your disclosed commodities in the reporting year. The disclosure of 28 land holdings is critical for understanding current and future risks and opportunities related to deforestation and conversion of other natural ecosystems.',
            heading: inputType.HEADING,
            colSpan: true,
            options: INDICATE_IF_LAND_OWN_MANAGED_OPTIONS
          }
        ]
      }
    ]
  },
  {
    key: 'Q7',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q7_VALUE,
        '8.4.1 Provide details on the land you own, manage and/or control that was not used to produce your disclosed commodities in the reporting year',
        'Organizations should be able to identify the land it owns, manages and/or controls which is not currently used to produce commodities, but may or may not be in the future. By disclosing this data, you provide investors and other data users insights on land stewardship in addition to potential challenges your organization may face in expanding production areas.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q7_1_VALUE,
            'Country/area',
            COUNTRY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q7_2_VALUE,
            'Type of control',
            LAND_CONTROL_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q7_3_VALUE,
            'Land type',
            LAND_USE_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q7_4_VALUE,
            'Area (hectares)',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q7_5_VALUE,
            '% covered by natural forests and other natural ecosystems',
            2
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q7_6_VALUE,
            'Please explain',
            2500
          )
        ],
        true,
        undefined,
        CDP_FORESTS_KEYS.Q6_VALUE,
        [
          'Some of the land we own manage and/or control is not used for production'
        ]
      )
    ]
  },
  {
    key: 'Q8',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q8_VALUE,
        '8.5 Provide details on the origins of your sourced volumes.',
        'This question provides data users with more clarity about your organization’s exposure to deforestation and conversion risks. This question will benefit disclosers through increased transparency and improved ability to identify risks to their business. Ambition The organization discloses on the origins of their sourced volume.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q8_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q8_2_VALUE,
            'Country/area of origin',
            COUNTRY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q8_3_VALUE,
            'First-level administrative division',
            JURISDICTION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q8_4_VALUE,
            'Specify the states or equivalent jurisdictions',
            2500,
            undefined,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q8_3_VALUE,
              condition: conditionType.NOT,
              values: ['States/equivalent jurisdictions']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q8_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['States/equivalent jurisdictions'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q8_5_VALUE,
            'Volume sourced from country/area of origin (metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q8_6_VALUE,
            'Source',
            PRODUCER_TYPES_OPTIONS,
            true
          ),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q8_7_VALUE,
            'List of supplier production and primary processing sites: names and locations (optional)'
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q8_8_VALUE,
            'Please explain',
            2500
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q3_VALUE,
        CDP_FORESTS_KEYS.Q3_3_VALUE,
        ['Sourced']
      )
    ]
  },

  {
    key: 'Q9',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '8.6 Does your organization produce or source palm oil derived biofuel?',
            'This question allows data users to understand the relevancy of palm oil derived biofuels to your organization.'
          ),
          createSelectField(CDP_FORESTS_KEYS.Q9_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q10',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q10_VALUE,
        '8.6.1 Provide details of how your organization produces or sources palm oil derived biofuel.',
        'This question provides investors and data users transparency on organization’s palm oil derived biofuel in terms of its associated volume and its origin.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q10_1_VALUE,
            'Volume type',
            VOLUME_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q10_2_VALUE,
            'Palm oil derived biofuel volume',
            2
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q10_3_VALUE,
            'Metric',
            METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q10_4_VALUE,
            'Country/area of origin',
            COUNTRY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q10_5_VALUE,
            'First-level administrative division',
            JURISDICTION_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q10_4_VALUE,
              condition: conditionType.NOT,
              values: ['Unknown origin']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q10_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['Unknown origin'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q10_6_VALUE,
            '% of disclosure volume',
            PERCENTAGE_DISCLOSURE_VOLUME_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q10_7_VALUE,
            'Biofuel material is sourced from smallholders',
            YES_NO_UNKNOWN_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q10_8_VALUE,
            'Comment (optional)',
            2500
          )
        ],
        true,
        undefined,
        CDP_FORESTS_KEYS.Q9_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q11',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q11_VALUE,
        '8.7 Did your organization have a no-deforestation or no-conversion target, or any other targets for sustainable production/ sourcing of your disclosed commodities, active in the reporting year?',
        'This question establishes whether organizations have targets for eliminating deforestation and conversion of other natural ecosystems in their value chain. Setting specific targets with clear progress indicators enables organizations to effectively implement their commitments, policies, and goals. Ambition The organization sets organization-wide timebound and quantifiable targets to eliminate deforestation and conversion of other natural ecosystems.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q11_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q11_2_VALUE,
            'Active no-deforestation or no-conversion target',
            ACTIVE_DEFORESTATION_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q11_3_VALUE,
            'No-deforestation or no-conversion target coverage',
            NO_DEFORESTATION_TARGET_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, we have a no-deforestation target',
                'Yes, we have a no-conversion target'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, we have a no-deforestation target',
                'Yes, we have a no-conversion target'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q11_4_VALUE,
            'Primary reason for not having an active no-deforestation or no-conversion target in the reporting year',
            TARGET_CHALLENGES_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q11_5_VALUE,
            'Explain why you did not have an active no-deforestation or no-conversion target in the reporting year',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to have a no-deforestation or no-conversion target in the next two years',
                'No, and we do not plan to have a no-deforestation or no-conversion target in the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to have a no-deforestation or no-conversion target in the next two years',
                'No, and we do not plan to have a no-deforestation or no-conversion target in the next two years'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q11_6_VALUE,
            'Other active targets related to this commodity, including any which contribute to your no-deforestation or no-conversion target',
            OTHER_COMMODITY_TARGET_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q11_7_VALUE,
            'Primary reason for not having other active targets in the reporting year',
            PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q11_8_VALUE,
            'Explain why you did not have other active targets in the reporting year',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q11_6_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to have other targets related to this commodity in the next two years',
                'No, and we do not plan to have other targets related to this commodity in the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q11_6_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to have other targets related to this commodity in the next two years',
                'No, and we do not plan to have other targets related to this commodity in the next two years'
              ],
              required: true
            }
          )
        ],
        false
      )
    ]
  },

  {
    key: 'Q12',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q12_VALUE,
        '8.7.1 Provide details on your no-deforestation or no-conversion target that was active during the reporting year.',
        'Ambition This question only appears if you select “Yes, we have a no-deforestation target”, or “Yes, we have a no-conversion target” in response to column “Active no-deforestation or no-conversion target” of 8.7. No change This question establishes how ambitious an organization’s no-conversion or no-deforestation targets are. Information disclosed about your targets provides data users with a way of tracking progress towards a sustainable value chain. Ambitious targets reflect how urgent issues related to deforestation and conversion of other natural ecosystems are being addressed by organizations. The organization sets timebound and quantifiable commodity specific targets to eliminate deforestation and conversion of other natural ecosystems.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q12_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q12_2_VALUE,
            'No-deforestation or no-conversion target',
            NO_DEFORESTATION_OR_NO_CONVERSION_TARGET_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q12_3_VALUE,
            'Your organization’s definition of “no-deforestation” or “no-conversion”',
            500
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q12_4_VALUE,
            'Cutoff date',
            CUTOFF_YEAR_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q12_5_VALUE,
            'Geographic scope of cutoff date',
            GEOGRAPHIC_SCOPE_CUTOFF_YEAR_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q12_4_VALUE,
              condition: conditionType.NOT,
              values: ['No cutoff date']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q12_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['No cutoff date'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q12_6_VALUE,
            'Rationale for selecting cutoff date',
            RATIONALE_SELECTING_CUTOFF_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q12_7_VALUE,
            'Target date for achieving no-deforestation or no-conversion',
            TARGET_DATE_OPTIONS
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q11_VALUE,
        CDP_FORESTS_KEYS.Q11_2_VALUE,
        [
          'Yes, we have a no-deforestation target',
          'Yes, we have a no-conversion target'
        ]
      )
    ]
  },

  {
    key: 'Q13',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q13_VALUE,
        '8.7.2 Provide details of other targets related to your commodities, including any which contribute to your no-deforestation or no-conversion target, and progress made against them.',
        'This question captures details on targets organizations have in place to implement their overall no-deforestation or no-conversion targets, or to improve the sustainability of commodity production and sourcing. Providing details on metrics and progress against targets helps data users understand whether organizations have relevant targets to address the dependencies, impacts, risks, and opportunities in their value chain. 48 Ambition The organization sets timebound and quantifiable commodity specific targets to contribute towards overall no-deforestation or no-conversion targets and/or to improve sustainable commodity production and sourcing.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_2_VALUE,
            'Target reference number',
            TARGET_LIST_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_3_VALUE,
            'Target contributes to no-deforestation or no-conversion target reported in 8.7',
            TARGET_CONTRIBUTION_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, we have a no-deforestation target',
                'Yes, we have a no-conversion target'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, we have a no-deforestation target',
                'Yes, we have a no-conversion target'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_4_VALUE,
            'Target coverage',
            TARGET_LEVEL_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_5_VALUE,
            'Commodity volume covered by target (metric tons)',
            TARGET_VOLUME_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_6_VALUE,
            'Category of target & Quantitative metric',
            TARGET_METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_7_VALUE,
            'Traceability point',
            TRACEABILITY_POINT_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_8_VALUE,
            'Third-party certification scheme',
            THIRD_PARTY_CERTIFICATION_SCHEME_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q13_6_VALUE,
              condition: conditionType.NOT,
              values: [
                '% of volume third-party certified',
                'Other third-party certification target metric, please specify.'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q13_6_VALUE,
              condition: conditionType.EQUALS,
              values: [
                '% of volume third-party certified',
                'Other third-party certification target metric, please specify.'
              ],
              required: true
            }
          ),
          createRowDatePickerField(
            CDP_FORESTS_KEYS.Q13_9_VALUE,
            'Date target was set'
          ),
          createRowDatePickerField(
            CDP_FORESTS_KEYS.Q13_10_VALUE,
            'End date of base year'
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q13_11_VALUE,
            'Base year figure',
            4
          ),
          createRowDatePickerField(
            CDP_FORESTS_KEYS.Q13_12_VALUE,
            'End date of target'
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q13_13_VALUE,
            'Target year figure',
            4
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q13_14_VALUE,
            'Reporting year figure',
            4
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q13_15_VALUE,
            'Target status in reporting year',
            TARGET_STATUS_REPORT_YEAR_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q13_16_VALUE,
            '% of target achieved relative to base year',
            4
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q13_17_VALUE,
            'Global environmental treaties/initiatives/frameworks aligned with or supported by this target',
            GLOBAL_ENVIRONMENTAL_TREATIES_OPTIONS,
            true
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q13_18_VALUE,
            'Explain target coverage and identify any exclusions',
            2500
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q13_19_VALUE,
            'Plan for achieving target, and progress made to the end of the reporting year',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q13_15_VALUE,
              condition: conditionType.NOT,
              values: ['New', 'Underway', 'Revised']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q13_15_VALUE,
              condition: conditionType.EQUALS,
              values: ['New', 'Underway', 'Revised'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q13_20_VALUE,
            'List the actions which contributed most to achieving or maintaining this target',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q13_15_VALUE,
              condition: conditionType.NOT,
              values: ['Achieved', 'Achieved and maintained']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q13_15_VALUE,
              condition: conditionType.EQUALS,
              values: ['Achieved', 'Achieved and maintained'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q13_21_VALUE,
            'Further details of target',
            2500
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q11_VALUE,
        CDP_FORESTS_KEYS.Q11_6_VALUE,
        ['Yes, we have other targets related to this commodity']
      )
    ]
  },

  {
    key: 'Q14',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q14_VALUE,
        '8.8 Indicate if your organization has a traceability system to determine the origins of your sourced volumes and provide details of the methods and tools used.',
        'Organizations should know or control the origins of their sourced commodities to eliminate deforestation and conversion of other natural ecosystems in their value chain. Robust traceability systems allow organizations to ascertain that the production and processing units of commodity origins are free from deforestation and conversion. This information helps investors and other data users assess whether organizations have the necessary traceability systems to determine the compliance of sourced volumes with their no-deforestation and no-conversion policies, targets, and goals, and the methodologies and tools involved. Ambition Organizations have robust traceability systems in place to ensure the origins of the sourced volumes across their value chain are known or controlled to a sufficient extent to determine the deforestation- and conversion-free status of production and processing units.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q14_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q14_2_VALUE,
            'Traceability system',
            TRACEABILITY_SYSTEM_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q14_3_VALUE,
            'Methods/tools used in traceability system',
            METHOD_TOOL_TRACEABILITY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q14_4_VALUE,
            'Description of methods/tools used in traceability system',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q14_2_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q14_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q14_5_VALUE,
            'Primary reason your organization does not have a traceability system',
            PRIMARY_REASON_ORGANIZATION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q14_6_VALUE,
            'Explain why your organization does not have a traceability system',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q14_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to establish one within the next two years',
                'No, and we do not plan to establish one within the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q14_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to establish one within the next two years',
                'No, and we do not plan to establish one within the next two years'
              ],
              required: true
            }
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q3_VALUE,
        CDP_FORESTS_KEYS.Q3_3_VALUE,
        ['Sourced']
      )
    ]
  },

  {
    key: 'Q15',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q15_VALUE,
        '8.8.1 Provide details of the point to which your organization can trace its sourced volumes.',
        'Organizations must understand and disclose the traceability levels of their sourced volumes to demonstrate their ability to assess compliance with no-deforestation and no-conversion policies, targets, and goals. This question helps investors and other data users understand the extent to which organizations know the origin of their commodities, and therefore their ability to determine deforestation- and conversion-free (DCF) status and identify their dependencies, impacts, risks, and opportunities.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q15_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q15_2_VALUE,
            '% of sourced volume traceable to production unit',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q15_3_VALUE,
            '% of sourced volume traceable to sourcing area and not to production unit',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q15_4_VALUE,
            '% of sourced volume traceable to country/area of origin and not to sourcing area or production unit',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q15_5_VALUE,
            '% of sourced volume traceable to other point (i.e., processing facility/first importer) not in the country/area of origin',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q15_6_VALUE,
            '% of sourced volume from unknown origin',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q15_7_VALUE,
            '% of sourced volume reported'
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q14_VALUE,
        CDP_FORESTS_KEYS.Q14_2_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q16',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q16_VALUE,
        `8.9 Provide details of your ${'organization'}'s assessment of the deforestation-free (DF) or deforestation- and conversion-free (DCF) status of its disclosed commodities.`,
        'Organizations should disclose the proportion of volumes in their direct operations and upstream value chain assessed and determined to be DF or DCF. The DF designation signifies that the production and sourcing of commodity volumes did not cause or contribute to deforestation since a specified cutoff date, while the DCF designation signifies that the production and sourcing of commodity volumes did not cause or contribute to deforestation and the conversion of other natural ecosystems since a specified cutoff date. This question helps data users understand organizations’ performance and progress towards DCF and the methods used to ascertain DF/DCF status.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q16_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q16_2_VALUE,
            'DF/DCF status assessed for this commodity',
            DF_DCF_STATUS_ASSESSED_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q16_3_VALUE,
            '% of disclosure volume determined as DF/DCF in the reporting year',
            2
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q16_4_VALUE,
            '% of disclosure volume determined as DF/DCF through a third-party certification scheme providing full DF/DCF assurance',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, deforestation and conversion-free (DCF) status assessed',
                'Yes, deforestation-free (DF) status assessed'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, deforestation and conversion-free (DCF) status assessed',
                'Yes, deforestation-free (DF) status assessed'
              ],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q16_5_VALUE,
            '% of disclosure volume determined as DF/DCF through monitoring of production unit',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, deforestation and conversion-free (DCF) status assessed',
                'Yes, deforestation-free (DF) status assessed'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, deforestation and conversion-free (DCF) status assessed',
                'Yes, deforestation-free (DF) status assessed'
              ],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q16_6_VALUE,
            '% of disclosure volume determined as DF/DCF through monitoring of sourcing area',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, deforestation and conversion-free (DCF) status assessed',
                'Yes, deforestation-free (DF) status assessed'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, deforestation and conversion-free (DCF) status assessed',
                'Yes, deforestation-free (DF) status assessed'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q16_7_VALUE,
            'Is a proportion of your disclosure volume certified through a scheme not providing full DF/DCF assurance?',
            YES_NO_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q16_8_VALUE,
            'Primary reason for not assessing DF/DCF status',
            PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q16_9_VALUE,
            'Explain why you have not assessed DF/DCF status',
            2500,
            undefined,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to do so within the next two years',
                'No, but we plan to do so within the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q16_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to do so within the next two years',
                'No, but we plan to do so within the next two years'
              ],
              required: true
            }
          )
        ],
        false
      )
    ]
  },

  {
    key: 'Q17',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q17_VALUE,
        '8.9.1 Provide details of third-party certification schemes used to determine the deforestation-free (DF) or deforestation- and conversion-free (DCF) status of the disclosure volume, since specified cutoff date.',
        'This question gathers information on the proportion of your disclosure volume determined to be DF or DCF using a third-party certification scheme providing full assurance of DF/DCF. Credible third-party certification is one method organizations can use to determine that no deforestation or conversion has occurred since a specified cutoff date and assure investors and other data users that their commodity volumes are DF/DCF.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q17_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q17_2_VALUE,
            'Third-party certification scheme providing full DF/DCF assurance',
            THIRD_PARTY_CERTIFICATION_SCHEME_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q17_3_VALUE,
            '% of disclosure volume determined as DF/DCF through certification scheme providing full DF/DCF assurance',
            2
          ),
          createRowWysiwygField(CDP_FORESTS_KEYS.Q17_4_VALUE, 'Comment', 2500),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q17_5_VALUE,
            'Certification documentation'
          )
        ],
        false
      )
    ]
  },
  {
    key: 'Q18',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q18_VALUE,
        '8.9.2 Provide details of third-party certification schemes not providing full DF/DCF assurance.',
        'This question gathers information on the proportion of your disclosure volume certified through third-party certification schemes that do not provide full DF or DCF assurance, used in combination with additional control methods to determine the DF/DCF status. Ambition Organizations use additional control methods to determine the DF/DCF status of volumes, where third-party certification schemes do not provide full assurance.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q18_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q18_2_VALUE,
            'Third-party certification scheme not providing full DF/DCF assurance',
            THIRD_PARTY_CERTIFICATION_SCHEME_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q18_3_VALUE,
            '% of disclosure volume certified through scheme not providing full DF/DCF assurance',
            2
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q18_4_VALUE,
            'Additional control methods in place to determine DF/DCF status of volumes certified through scheme not providing full DF/DCF assurance',
            ADDITIONAL_CONTROL_METHODS_OPTIONS
          ),
          createRowWysiwygField(CDP_FORESTS_KEYS.Q18_5_VALUE, 'Comment', 2500),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q18_6_VALUE,
            'Certification documentation'
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q16_VALUE,
        CDP_FORESTS_KEYS.Q16_7_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q19',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q19_VALUE,
        '8.9.3 Provide details of production unit monitoring used to determine deforestation-free (DF) or deforestation- and conversion-free (DCF) status of volumes since specified cutoff date.',
        'This question gathers information on the proportion of the disclosure volume that has been determined to be DF or DCF via monitoring of the production unit for deforestation and conversion. Regular monitoring of the production unit is one method organizations can use to determine that no deforestation or conversion has occurred since a specified cutoff date and assure investors and other data users that their commodity volumes are DF/DCF.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q19_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q19_2_VALUE,
            '% of disclosure volume determined as DF/DCF through monitoring of production unit'
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q19_3_VALUE,
            'Production unit monitoring approach',
            PRODUCTION_UNIT_MONITORING_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q19_4_VALUE,
            'Description of production unit monitoring approach',
            2500
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q19_5_VALUE,
            'DF/DCF status verified',
            YES_NO_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q19_6_VALUE,
            'Type of verification',
            TYPE_OF_VERIFICATION_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q19_7_VALUE,
            '% of your disclosure volume that is both determined as DF/DCF through monitoring of production unit and is verified as DF/DCF',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q19_8_VALUE,
            'Explain the process of verifying DF/DCF status',
            2500,
            undefined,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q19_9_VALUE,
            'Attachment of verification (optional)',
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q19_5_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            }
          )
        ],
        false
      )
    ]
  },

  {
    key: 'Q20',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q20_VALUE,
        '8.9.4 Provide details of the sourcing area monitoring used to determine deforestation-free (DF) or deforestation- and conversion-free (DCF) status of volumes since specified cutoff date.',
        'Commodity volumes can be claimed to be DF or DCF if they originate in sourcing areas where there is no or negligible risk that deforestation and/or conversion has occurred related to that commodity since an appropriate cutoff date. Determining this risk requires ongoing monitoring of the sourcing area. This question helps data users understand whether your organization is making DF/DCF claims based on sourcing area-level risk assessment, and how your organization is monitoring those sourcing areas to ensure the absence of deforestation or conversion risk.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q20_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q20_2_VALUE,
            '% of disclosure volume determined as DF/DCF through monitoring of deforestation and conversion within the sourcing area'
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q20_3_VALUE,
            'Monitoring approach used for determining that sourcing areas have no or negligible risk of deforestation or conversion',
            MONITORING_APPROACH_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q20_4_VALUE,
            'Description of approach, including frequency of assessment',
            4000
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q20_5_VALUE,
            'Countries/areas of origin',
            COUNTRY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q20_6_VALUE,
            'Sourcing areas ',
            2500
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q20_7_VALUE,
            'DF/DCF status is verified',
            YES_NO_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q20_8_VALUE,
            'Type of verification',
            TYPE_OF_VERIFICATION_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q20_7_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q20_7_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q20_9_VALUE,
            '% of your disclosure volume that is both determined as DF/DCF through sourcing area monitoring and is verified as DF/DCF',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q20_7_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q20_7_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q20_10_VALUE,
            'Explain the process of verifying DF/DCF status',
            2500,
            undefined,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q20_7_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q20_7_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q20_11_VALUE,
            'Attachment of verification (optional)'
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q20_12_VALUE,
            'Use of risk classification',
            4000
          ),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q20_13_VALUE,
            'Attachment indicating risk classification for each sourcing area (optional)'
          )
        ],
        false
      )
    ]
  },

  {
    key: 'Q21',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q21_VALUE,
        '8.10 Indicate whether you have monitored or estimated the deforestation and conversion of other natural ecosystems footprint for your disclosed commodities.',
        'No change Monitoring and estimating the deforestation and conversion footprint associated with commodity production or sourcing is key to understanding the scale of your impacts. The organization assesses and discloses the deforestation and natural ecosystems conversion footprint in its direct operations and/or value chain. Ambition',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q21_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q21_2_VALUE,
            'Monitoring or estimating your deforestation and conversion footprint',
            MONITORING_OR_ESTIMATING_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q21_3_VALUE,
            'Primary reason for not monitoring or estimating deforestation and conversion footprint',
            PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q21_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to monitor or estimate our deforestation and conversion footprint in the next two years',
                'No, and we do not plan to monitor or estimate our deforestation and conversion footprint in the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q21_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to monitor or estimate our deforestation and conversion footprint in the next two years',
                'No, and we do not plan to monitor or estimate our deforestation and conversion footprint in the next two years'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q21_4_VALUE,
            'Explain why you do not monitor or estimate your deforestation and conversion footprint',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q21_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but we plan to monitor or estimate our deforestation and conversion footprint in the next two years',
                'No, and we do not plan to monitor or estimate our deforestation and conversion footprint in the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q21_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but we plan to monitor or estimate our deforestation and conversion footprint in the next two years',
                'No, and we do not plan to monitor or estimate our deforestation and conversion footprint in the next two years'
              ],
              required: true
            }
          )
        ],
        false
      )
    ]
  },
  {
    key: 'Q22',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q22_VALUE,
        '8.10.1 Provide details on the monitoring or estimating of your deforestation and conversion footprint.',
        'Disclosure of the extent to which your organization monitors or estimates its deforestation and conversion footprint on land you own, manage or control, and/or within your upstream value 93 chain, provides investors and other data users with an understanding of the scale of your impacts related to deforestation and conversion of other natural ecosystems. This question allows organizations to demonstrate transparency and awareness of the relationship between natural ecosystems and their business activities. The organization assesses and discloses the deforestation and natural ecosystems conversion footprint in its direct operations and/or upstream value chain.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q22_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q22_2_VALUE,
            'Monitoring and estimating your deforestation and conversion footprint',
            MONITORING_AND_ESTIMATING_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q22_3_VALUE,
            '% of disclosure volume monitored or estimated'
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q22_4_VALUE,
            'Reporting of deforestation and conversion footprint',
            REPORTING_OF_DEFORESTATION_OPTIONS,
            true
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q22_5_VALUE,
            'Year of cutoff date',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['Since a specified cutoff date']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['Since a specified cutoff date'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q22_6_VALUE,
            'Known or estimated deforestation and conversion footprint in the reporting period (hectares)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['During the reporting period']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['During the reporting period'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q22_7_VALUE,
            'Known or estimated deforestation and conversion footprint since the specified cutoff date (hectares)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['Since a specified cutoff date']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['Since a specified cutoff date'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q22_8_VALUE,
            'Known or estimated deforestation and conversion footprint during the last five years (hectares)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['During the last 5 years']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['During the last 5 years'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q22_9_VALUE,
            'Known or estimated deforestation and conversion footprint since other specified point (hectares)',
            2,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: ['Other, please specify']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q22_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['Other, please specify'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q22_10_VALUE,
            'Describe the methods and data sources used to monitor or estimate your deforestation and conversion footprint',
            1500
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q21_VALUE,
        CDP_FORESTS_KEYS.Q21_2_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q23',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q23_VALUE,
        '8.11 For volumes not assessed and determined as deforestation- and conversion-free (DCF), indicate if you have taken actions in the reporting year to increase production or sourcing of DCF volumes.',
        'This question allows organizations to disclose actions taken in the reporting year related to volumes that are not yet assessed and determined as DCF. Achieving deforestation- and conversion-free value chains may take longer for organizations engaging in transformative actions across sourcing landscapes. This question allows data users to understand the actions your organization is taking to address environmental or social issues related to commodity production/sourcing and if and how these actions contribute to determining the DCF status of commodity volumes or remediate past conversion.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q23_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q23_2_VALUE,
            'Actions taken to increase production or sourcing of DCF volumes',
            PROCESS_PLACE_OPTIONS
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q16_VALUE,
        CDP_FORESTS_KEYS.Q16_2_VALUE,
        ['Yes, deforestation and conversion-free (DCF) status assessed']
      )
    ]
  },
  {
    key: 'Q24',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q24_VALUE,
        '8.11.1 Provide details of actions taken in the reporting year to assess and increase production/sourcing of deforestation- and conversion-free (DCF) volumes.',
        'Organizational approaches to achieving DCF status should support efforts to halt deforestation and conversion on the ground by working with non-compliant suppliers, ensuring smallholder inclusion, and working collaboratively in production landscapes. Achieving deforestation- and conversion-free value chains may take longer for organisations engaging in transformative actions across sourcing landscapes. This question allows data users to understand whether your organization is taking action to address environmental or social issues related to commodity production/sourcing and if and how these actions contribute to determining the DCF status of commodity volumes.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q24_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q24_2_VALUE,
            'Action type',
            ACTION_TYPE
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q24_3_VALUE,
            '% of disclosure volume that is covered by this action',
            3
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q24_4_VALUE,
            'Indicate whether you had any major barriers or challenges related to this action in the reporting year',
            YES_NO_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q24_5_VALUE,
            'Main measures identified to manage or resolve the challenges',
            MAIN_MEASURES_IDENTIFIED_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q24_4_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q24_4_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q24_6_VALUE,
            'Provide further details on the actions taken, their contribution to achieving DCF status, and any related barriers or challenges',
            2500
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q23_VALUE,
        CDP_FORESTS_KEYS.Q23_2_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q25',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q25_VALUE,
        '8.12 Indicate if certification details are available for the commodity volumes sold to requesting CDP',
        'No change This information will provide clarity to CDP Supply Chain members on whether data is available for the percentage of the total commodity volume bought from your organization that is certified by a third party. This meets the transparency expectations from requesting members and allows organizations to disclose their progress on securing a supply of sustainable raw materials and/or products. Additionally, this question allows CDP Supply Chain members to understand the primary reasons for not disclosing certification details for the volumes sold by your organization. This provides insight into the main challenges in this area and informs members on plans to address these challenges.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q25_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q25_2_VALUE,
            'Third-party certification scheme adopted',
            PROCESS_PLACE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q25_3_VALUE,
            'Certification details are available for the volumes sold to any requesting CDP Supply Chain members',
            CERTIFICATE_DETAILS_VOLUME_SOLID_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q25_4_VALUE,
            'Primary reason certification details are not available for the volumes sold to any requesting CDP Supply Chain members',
            PRIMARY_REASON_CERTIFICATION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q25_5_VALUE,
            'Explain why certification details are not available for the volumes sold to any requesting CDP Supply Chain members',
            2400
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q25_6_VALUE,
            'Primary reason that third-party certification has not been adopted',
            PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q25_7_VALUE,
            'Explain why third-party certification has not been adopted',
            2400
          )
        ],
        false
      )
    ]
  },
  {
    key: 'Q26',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q26_VALUE,
        '8.12.1 Provide details of the certified volumes sold to each requesting CDP Supply Chain member.',
        'This question gathers details on the percentage of the total commodity volume bought from your organization that is certified by a third party, the certification schemes used and forms of commodities that are certified.',
        [
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q26_1_VALUE,
            'Requesting member'
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q26_2_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q26_3_VALUE,
            'Form of commodity',
            FORM_OF_COMMODITY_OPTIONS,
            true
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q26_4_VALUE,
            'Total volume of commodity sold to requesting member',
            2
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q26_5_VALUE,
            'Metric',
            MEASUREMENT_UNITS_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q26_6_VALUE,
            'Third-party certification scheme',
            THIRD_PARTY_CERTIFICATION_SCHEME_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q26_7_VALUE,
            '% of the total volume of commodity sold to requesting member that is certified',
            2
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q26_8_VALUE,
            'Comment (optional)',
            1000
          )
        ],
        true,
        CDP_FORESTS_KEYS.Q25_VALUE,
        CDP_FORESTS_KEYS.Q25_2_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q27',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q27_VALUE,
        '8.13 Does your organization calculate the GHG emission reductions and/or removals from land use management and land use change that have occurred in your direct operations and/or upstream value chain?',
        'No change Understanding the GHG emissions reductions/removals from land use management and land use change can inform mitigation strategies. This question enables requesting CDP Supply Chain members to understand progress towards emissions reduction targets and it allows organizations to assess progress with regards to reducing emissions beyond business-as-usual scenarios (beyond standard maintenance/ replacement activities).',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q27_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q27_2_VALUE,
            'GHG emissions reductions and removals from land use management and land use change calculated',
            GHG_EMISSIONS_REDUCTIONS_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q27_3_VALUE,
            'Primary reason your organization does not calculate GHG emissions reductions and removals from land use management and land use change',
            PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q27_4_VALUE,
            'Explain why your organization does not calculate GHG emissions reductions and removals from land use management and land use change',
            2400,
            undefined,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q27_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'No, but plan to do so in the next two years',
                'No, and do not plan to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q27_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'No, but plan to do so in the next two years',
                'No, and do not plan to do so in the next two years'
              ],
              required: true
            }
          )
        ],
        false
      )
    ]
  },
  {
    key: 'Q28',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q28_VALUE,
        '8.13.1 Provide details on the actions your organization has taken in its direct operations and/or upstream value chain that have resulted in reduced GHG emissions and/or enhanced removals.',
        'Understanding the GHG emissions/removals from land use management and land use change can inform mitigation strategies. This question enables CDP supply chain requesting members to understand progress towards emissions targets and it allows organizations to assess progress with regards to reducing emissions beyond business-as-usual scenarios (beyond standard maintenance/replacement activities).',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q28_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q28_2_VALUE,
            'Description of actions',
            2400
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q28_3_VALUE,
            'CO2e reductions and removals achieved from base year (metric tons CO2e)',
            2
          ),
          createRowNumberField(CDP_FORESTS_KEYS.Q28_4_VALUE, 'Base year'),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q28_5_VALUE,
            'Emissions accounting boundary',
            EMISSIONS_ACCOUNTING_BOUNDARY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q28_6_VALUE,
            'Scope',
            SCOPE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q28_7_VALUE,
            'Emissions accounting methodology and standards',
            EMISSIONS_ACCOUNTING_METHODOLOGY_OPTIONS,
            true
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q28_8_VALUE,
            'Explain calculation',
            1000
          )
        ],
        true,
        CDP_FORESTS_KEYS.Q27_VALUE,
        CDP_FORESTS_KEYS.Q27_2_VALUE,
        [
          'Yes, and willing to share details with requesting CDP Supply Chain members'
        ]
      )
    ]
  },

  {
    key: 'Q29',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q29_VALUE,
        '8.14 Indicate if you assess your own compliance and/or the compliance of your suppliers with forest',
        'This question gathers data on how your organization assessed compliance with forest laws and regulations in its direct operations and the rest of its value chain within the reporting year. Assessment of applicable laws is an important aspect of social and environmental due diligence, and good practice that promotes legal compliance in the countries/areas of origin of commodities, including when acquiring lands and resources. For those organizations with operations in Brazil, compliance with the Brazilian Forest Code indicates that organizations are working to ensure their production in Brazil is compliant with national legislation.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q29_1_VALUE,
            'Assess legal compliance with forest regulations',
            ASSESS_LEGAL_COMPLIANCE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q29_2_VALUE,
            'Aspects of legislation considered',
            ASPECTS_OF_LEGISLATION_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q29_1_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, from suppliers',
                'Yes, from owned, managed and/or controlled land',
                'Yes, from both suppliers and owned/managed/controlled land'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q29_1_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, from suppliers',
                'Yes, from owned, managed and/or controlled land',
                'Yes, from both suppliers and owned/managed/controlled land'
              ],
              required: true
            }
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q29_3_VALUE,
            'Procedure to ensure legal compliance',
            PROCEDURE_TO_ENSURE_LEGAL_COMPLIANCE_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q29_1_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, from suppliers',
                'Yes, from owned, managed and/or controlled land',
                'Yes, from both suppliers and owned/managed/controlled land'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q29_1_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, from suppliers',
                'Yes, from owned, managed and/or controlled land',
                'Yes, from both suppliers and owned/managed/controlled land'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q29_4_VALUE,
            'Indicate if you collect data regarding compliance with the Brazilian Forest Code',
            INDICATE_COLLECT_COMPLIANCE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q29_5_VALUE,
            'Please explain',
            5000
          )
        ],
        false
      )
    ]
  },

  {
    key: 'Q30',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q30_VALUE,
        '8.15 Do you engage in landscape (including jurisdictional) initiatives to progress shared sustainable land use goals?',
        'A growing number of organizations, as well as platforms such as the Consumer Goods Forum and the Soft Commodities Forum, are incorporating landscape and jurisdictional approaches and initiatives as a part of corporate sustainability strategies. Working collaboratively with multiple actors at landscape and jurisdictional scale is increasingly accepted as a best practice approach to driving conservation and restoration impacts at scale, tackling deforestation and conversion commitments through a value chain and achieving sustainability goals, especially where there are systemic challenges in production landscapes. This question helps data users to understand which organizations are taking this approach and engaging in such landscape and jurisdictional initiatives.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q30_1_VALUE,
            'Engagement in landscape/jurisdictional initiatives',
            ENGAGEMENT_IN_LANDSCAPE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q30_2_VALUE,
            'Primary reason for not engaging in landscape/jurisdictional initiatives',
            PRIMARY_REASON_FOR_NOT_ENGAGING_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q30_3_VALUE,
            'Explain why your organization does not engage in landscape/jurisdictional initiatives',
            1500
          )
        ],
        false
      )
    ]
  },
  {
    key: 'Q31',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q31_VALUE,
        '8.15.1 Indicate the criteria you consider when prioritizing landscapes and jurisdictions for engagement in collaborative approaches to sustainable land use and provide an explanation.',
        'To effectively address deforestation, achieve sustainability targets, and to secure supply chain operations, organizations need to actively engage in the landscapes/jurisdictions they depend on. They will likely have key knowledge and expertise to share with existing initiatives and be able to progress shared goals effectively. Investors and other data users are interested in knowing how organizations identify collaborations that maximize value and positive impact. Prioritizing a landscape should go beyond a country/area level analysis to the regions within a value chain that pose the highest risk from deforestation and conversion. It will also identify landscapes that present opportunities for collaboration, such as governmental commitments and the presence of existing initiatives, including for production, conservation, and restoration activities. This requires an understanding of the overlay between footprint and risk/opportunity within these production landscapes. It is critical that organizations establish a definition for the priority landscapes within their sourcing footprint, and a set of criteria for choosing which landscape to engage in – such as a risk of non-compliance with sourcing policies or the presence of conditions that foster meaningful engagement. This ensures that the engagement and type of intervention integrates with the organization’s sustainability strategy and risk assessment approach. Prioritizing action is important to maximize the potential impact of the engagement. It is important to consider enabling conditions both in the landscape/jurisdiction and in the organization.',
        [
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q31_1_VALUE,
            'Criteria for prioritizing landscapes/jurisdictions for engagement',
            CRITERIA_FOR_PRIORITIZING_LANDSCAPE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q31_2_VALUE,
            'Explain your process for prioritizing landscapes/jurisdictions for engagement',
            2500
          )
        ],
        false,
        CDP_FORESTS_KEYS.Q30_VALUE,
        CDP_FORESTS_KEYS.Q30_1_VALUE,
        ['Yes, we engage in landscape/jurisdictional initiatives']
      )
    ]
  },
  {
    key: 'Q32',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q32_VALUE,
        '8.15.2 Provide details of your engagement with landscape/jurisdictional initiatives to sustainable land use during the reporting year',
        'This question allows data users to understand: the landscape/jurisdictional initiatives you engage with, the nature of the engagement, the sustainability goals supported by your organization’s activities, the investment, and how progress is monitored. Working collaboratively with multiple actors at a landscape and jurisdictional scale is increasingly accepted as a best practice approach to driving conservation and restoration results at scale, transitioning towards deforestation and conversion free production and achieving sustainability goals, especially where there are systemic challenges in production landscapes. Responses will provide valuable insights into good practice for corporate involvement in landscape and jurisdictional initiatives.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_1_VALUE,
            'Landscape/jurisdiction ID',
            LANDSCAPE_JURISDICATION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q32_2_VALUE,
            'Name of initiative',
            500
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_3_VALUE,
            'Country/area',
            COUNTRY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q32_4_VALUE,
            'Name of landscape or jurisdiction area',
            500
          ),
          createRowFileUploadField(
            CDP_FORESTS_KEYS.Q32_5_VALUE,
            'Attach public information about the initiative (optional)'
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_6_VALUE,
            'Indicate if you can provide the size of the area covered by the initiative',
            INDICATE_SIZE_OF_AREA_INITIATIVE_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q32_7_VALUE,
            'Area covered by the initiative (ha)',
            4,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q32_6_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q32_6_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q32_8_VALUE,
            'Type of engagement',
            TYPE_OF_ENGAGEMENT_OPTIONS,
            true
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q32_9_VALUE,
            'Engagement start year'
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_10_VALUE,
            'Engagement end year',
            ENGAGEMENT_END_YEAR_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q32_11_VALUE,
            'Estimated investment over the project period',
            2
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_12_VALUE,
            'Landscape goals supported by engagement',
            LANDSCAPE_GOALS_SUPPORTED_BY_ENGAGEMENT_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_13_VALUE,
            'Organization actions supporting initiative',
            ORGANIZATION_ACTIONS_SUPPORTING_INITIATIVE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q32_14_VALUE,
            'Type of partners engaged in the initiative design and implementation',
            TYPE_OF_PARTNERS_ENGAGED_IN_INITIATIVE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q32_15_VALUE,
            'Description of engagement',
            2500
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_16_VALUE,
            'Collective monitoring framework used to measure progress towards landscape goals and actions',
            COLLECTIVE_MONITORING_FRAMEWORK_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q32_17_VALUE,
            'State the achievements of your engagement so far and how progress is monitored',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q32_16_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, progress is collectively monitored using a shared external framework, please specify'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q32_16_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, progress is collectively monitored using a shared external framework, please specify'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_18_VALUE,
            'Claims made',
            CLAIM_STATUS_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q32_19_VALUE,
            'Type of claim made',
            CLAIM_TYPE_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q32_18_VALUE,
              condition: conditionType.NOT,
              values: ['Yes, we are making a claim']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q32_18_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes, we are making a claim'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q32_20_VALUE,
            'Provide further details on your claim',
            2500,
            undefined,
            undefined,
            {
              fieldName: CDP_FORESTS_KEYS.Q32_18_VALUE,
              condition: conditionType.NOT,
              values: ['Yes, we are making a claim']
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q32_18_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes, we are making a claim'],
              required: true
            }
          )
        ],
        true,

        CDP_FORESTS_KEYS.Q30_VALUE,
        CDP_FORESTS_KEYS.Q30_1_VALUE,
        ['Yes, we engage in landscape/jurisdictional initiatives']
      )
    ]
  },
  {
    key: 'Q33',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q33_VALUE,
        '8.15.3 For each of your disclosed commodities, provide details on the disclosure volume from each of the landscapes/jurisdictions you engage in.',
        'Disclosing your produced or sourced volumes from each landscape/jurisdiction demonstrates whether collaborative engagement contributes to your own strategy for increasing sustainable production/sourcing. It also helps data users to understand how your engagement in landscape/jurisdictional initiatives relate to your sourcing of commodities. The organization reports volumes of the commodities produced and/or sourced from the landscapes and jurisdictions in which they engage.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q33_1_VALUE,
            'Landscape/jurisdiction ID',
            LANDSCAPE_JURISDICATION_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q33_2_VALUE,
            'Does any of your produced and/or sourced commodity volume originate from this landscape/jurisdiction, and are you able/willing to disclose information on this volume?',
            PRODUCE_SOURCE_DISCLOSURE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q33_3_VALUE,
            'Commodity',
            COMMODITY_OPTIONS,
            true,
            {
              fieldName: CDP_FORESTS_KEYS.Q33_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, we do produce/source from this landscape/jurisdiction, and we are able/willing to disclose volume data'
              ]
            },
            {
              fieldName: CDP_FORESTS_KEYS.Q33_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, we do produce/source from this landscape/jurisdiction, and we are able/willing to disclose volume data'
              ],
              required: true
            }
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q33_4_VALUE,
            '% of disclosure volume from this landscape/jurisdiction',
            2
          )
        ],
        true,
        CDP_FORESTS_KEYS.Q30_VALUE,
        CDP_FORESTS_KEYS.Q30_1_VALUE,
        ['Yes, we engage in landscape/jurisdictional initiatives']
      )
    ]
  },

  {
    key: 'Q34',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '8.16 Do you participate in any other external activities to support the implementation of policies and commitments related to deforestation, ecosystem conversion, or human rights issues in commodity value chains ',
            'Beyond landscape and jurisdictional approaches, involvement in other external activities brings together actors in a sector to establish shared objectives, develop plans, and take action to overcome challenges that can help the organization improve its production/sourcing practices and address broader issues in sectors or production landscapes. There may also be opportunities for driving innovation in the market and finding solutions to the challenges associated with the production and sourcing of sustainable raw materials. Organizations participate in collaborative activities address challenges related to deforestation, ecosystem conversion, or human rights abuses in commodity value chains.'
          ),
          createSelectField(CDP_FORESTS_KEYS.Q34_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q35',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q35_VALUE,
        '8.16.1 Provide details of the external activities to support the implementation of your policies and commitments related to deforestation, ecosystem conversion, or human rights issues in commodity value chains',
        'Beyond landscape and jurisdictional approaches, involvement in other external activities brings together actors in a sector to establish shared objectives, develop plans, and take action to overcome challenges that can help the organization improve its production/sourcing practices and address broader issues in sectors or production landscapes. There may also be opportunities for driving innovation in the market and finding solutions to the challenges associated with the production and sourcing of sustainable raw materials. Organizations participate in collaborative activities address challenges related to deforestation, ecosystem conversion, or human rights abuses in commodity value chains.',
        [
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q35_1_VALUE,
            'Commodity',
            COMMODITY_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q35_2_VALUE,
            'Activities',
            ACTIVITIES_ENGAGEMENT_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q35_3_VALUE,
            'Country/area',
            COUNTRY_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q35_4_VALUE,
            'Subnational area',
            SUBNATIONAL_AREA_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q35_5_VALUE,
            'Provide further details of the activity',
            2500
          )
        ],
        true,

        undefined,
        CDP_FORESTS_KEYS.Q34_VALUE,
        ['Yes']
      )
    ]
  },

  {
    key: 'Q36',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '8.17 Is your organization supporting or implementing project(s) focused on ecosystem restoration and long-term protection?',
            'This question gathers data on the projects your organization has supported or implemented, or plan to implement in two years, that are related to ecosystem restoration, reforestation and/or protection of forests and other ecosystems. This information demonstrates to investors and other data users that your organization is committed and proactive towards forests stewardship.'
          ),
          createSelectField(
            CDP_FORESTS_KEYS.Q36_VALUE,
            '',
            ORGANIZATION_SUPPORT_OR_IMPLEMENTING_PROJECT_OPTIONS
          )
        ]
      }
    ]
  },

  {
    key: 'Q37',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FORESTS_KEYS.Q37_VALUE,
        '8.17.1 Provide details on your project(s), including the extent, duration, and monitoring frequency. Please specify any measured outcome(s).',
        'This question gathers data on the projects your organization has supported or implemented, that are related to ecosystem restoration, reforestation and/or conservation of forests and other ecosystems. This information demonstrates to CDP’s investors and other data users that your organization is strongly committed and proactive towards sustainable forests stewardship.',
        [
          createRowSelectField(
            CDP_FORESTS_KEYS.Q37_1_VALUE,
            'Project reference',
            PROJECT_REFERENCE_OPTIONS
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q37_2_VALUE,
            'Project type',
            PROJECT_TYPE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q37_3_VALUE,
            'Expected benefits of project',
            EXPECTED_BENEFITS_OF_PROJECT_OPTIONS,
            true
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q37_4_VALUE,
            'Is this project originating any carbon credits?',
            YES_NO_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q37_5_VALUE,
            'Description of project'
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q37_6_VALUE,
            'Where is the project taking place in relation to your value chain?',
            PROJECT_TAKING_PLACE_RELATION_OPTIONS,
            true
          ),
          createRowNumberField(CDP_FORESTS_KEYS.Q37_7_VALUE, 'Start year'),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q37_8_VALUE,
            'Target year',
            TARGET_YEAR_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q37_9_VALUE,
            'Project area to date (Hectares)'
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q37_10_VALUE,
            'Project area in the target year (Hectares)'
          ),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q37_11_VALUE,
            'Country/Area',
            COUNTRY_OPTIONS
          ),
          createRowNumberField(CDP_FORESTS_KEYS.Q37_12_VALUE, 'Latitude'),
          createRowNumberField(CDP_FORESTS_KEYS.Q37_13_VALUE, 'Longitude'),
          createRowSelectField(
            CDP_FORESTS_KEYS.Q37_14_VALUE,
            'Monitoring frequency',
            MONITORING_FREQUENCY_OPTIONS
          ),
          createRowNumberField(
            CDP_FORESTS_KEYS.Q37_15_VALUE,
            'Total investment over the project period (currency)'
          ),
          createRowMultiSelectField(
            CDP_FORESTS_KEYS.Q37_16_VALUE,
            'For which of your expected benefits are you monitoring progress?',
            MONITORING_PROGRESS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FORESTS_KEYS.Q37_17_VALUE,
            'Please explain',
            2400
          )
        ],
        true,
        undefined,
        CDP_FORESTS_KEYS.Q36_VALUE,
        ['Yes']
      )
    ]
  }
];
